<template>
    <form :class="['page-view', {loaded: !loading}]" @submit="submit">
        <Breadcrumb/>
        <transition name="fade" mode="out-in">
            <div class="page-view-gabarit">
                <div class="heading separated">
                    <div class="block">
                        <h1>{{$t('technicalguide.title')}}</h1>
                        <p class="baseline">{{$t('technicalguide.baseline')}}</p>
                    </div>
                </div>
                <div class="form separated">
                    <div class="block">
                        <div class="row">
                            <div class="box">
                                <input
                                    type="text"
                                    v-model="lastname"
                                    :placeholder="$t('technicalguide.lastname')"
                                    v-validate="'required'"
                                />
                            </div>
                            <div class="box">
                                <input
                                    type="text"
                                    v-model="firstname"
                                    :placeholder="$t('technicalguide.firstname')"
                                    v-validate="'required'"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="box">
                                <input
                                    type="text"
                                    name="role"
                                    v-model="jobtitle" :placeholder="$t('technicalguide.jobtitle')"
                                />
                            </div>
                            <div class="box">
                                <input
                                    type="text"
                                    name="company"
                                    v-model="company" :placeholder="$t('technicalguide.company')"
                                    v-validate="'required'"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="box">
                                <input
                                    type="text"
                                    v-model="email"
                                    :placeholder="$t('technicalguide.email')"
                                    v-validate="'required|email'"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="box">
                                <input
                                    type="text"
                                    v-model="address"
                                    :placeholder="$t('technicalguide.address')"
                                    v-validate="'required'"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="box">
                                <input
                                    type="text"
                                    v-model="zip"
                                    :placeholder="$t('technicalguide.zip')"
                                />
                            </div>
                            <div class="box">
                                <input
                                    type="text"
                                    v-model="town"
                                    :placeholder="$t('technicalguide.town')"
                                />
                            </div>
                            <div class="box">
                                <input
                                    type="text"
                                    name="country"
                                    v-model="country"
                                    :placeholder="$t('technicalguide.country')"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="details separated">
                    <div class="block">
                        <div class="row">
                            <div class="box select">
                                <label for="number-select">{{$t('technicalguide.numbersofcopies')}}</label>
                                <select id="number-select" v-model="copies">
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                </select>
                            </div>
                            <div class="box select">
                                <label for="language-select">{{$t('technicalguide.language')}}</label>
                                <select id="language-select" v-model="language">
                                    <option value="English">English</option>
                                    <option value="French">Français</option>
                                    <option value="Spanish">Español</option>
                                </select>
                            </div>
                        </div>
                        <p>{{$t('technicalguide.morecopies')}}{{$t('technicalguide.contactus')}}</p>
                    </div>
                </div>
                <div class="footer">
                    <div class="block">
                        <div class="row">
                            <div class="box">
                                <p v-html="$t('technicalguide.data')"></p>
                                <input type="checkbox" id="optin" name="optin" value="newsletter"/>
                                <label for="optin">{{$t('technicalguide.optin')}}</label>
                                <p>{{$t('technicalguide.requiredfields')}}</p>
                            </div>
                            <div class="submit-container">
                                <Cta
                                    :type="'button'"
                                    @click.native="submit"
                                     :class="['link', {disabled: fetching}]"
                                    :colors="{ default: { background: '#ff2b2a', color: '#ffffff' }, hover: { background: '#ffffff', color: '#ff2b2a' } }"
                                >
                                    {{$t('technicalguide.submit')}}
                                </Cta>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </form>
</template>

<script>
import PageView from '@/components/MixinPageView'
import Cta from '@/components/Cta'
import {technicalGuideRequest} from '@/store/api/CRM'
export default {
    name: 'page',
    mixins: [PageView],
    components: {
        Cta
    },
    data() {
        return {
            lastname: '',
            firstname: '',
            jobtitle: '',
            email: '',
            country: '',
            company: '',
            address: '',
            zip: '',
            town: '',
            copies: 1,
            language: 'English',
            fetching: false
        }
    },
    watch: {
        '$route.params.locale'() {
            // this.requestData()
        }
    },
    created()
    {
        this.$nextTick(() => {
            this.loading = false
        })
    },
    methods: {
        submit(e) {
            e.preventDefault();
            if(this.fetching) {
                return
            }

            this.$validator.validate().then(valid => {
                if (!valid) {
                } else {
                    this.validateSuccess()
                }
            });
        },
        validateSuccess()
        {
            this.fetching = true
            const {lastname,
            firstname,
            jobtitle,
            email,
            country,
            company,
            address,
            zip,
            town,
            copies,
            language } = this

            technicalGuideRequest({lastname,
            firstname,
            jobtitle,
            email,
            country,
            company,
            address,
            zip,
            town,
            copies,
            language })
            .then(res => {
            this.lastname = ""
            this.firstname = ""
            this.jobtitle = ""
            this.email = ""
            this.country = ""
            this.company = ""
            this.address = ""
            this.zip = ""
            this.town = ""
            this.fetching = false
            })
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.page-view-gabarit
    overflow-y: visible
.page-view-gabarit
    .block
        margin-top: 4%
        margin-bottom: 4%
        max-width: 1590px
        margin-left: auto
        margin-right: auto
        display: flex
        flex-direction: column
        padding-left: 9.6%
        padding-right: 9.6%
    .row
        display: flex
        @include media-breakpoint-down($md)
            flex-direction: column
        &+.row
            margin-top: 4.25%
.heading
    margin-top: 8.25%

    &:after
        margin-top: 7.5%
.separated
    &:after
        content: ""
        display: block
        width: 100%
        height: 4px
        background-image: url('./../../assets/circle.svg')
        height: 12px
        opacity: .3
.box
    flex: 1
    &+.box
        margin-left: 80px
        @include media-breakpoint-down($md)
            margin-left: 0px
.radio
    display: flex
    align-items: center
h1
    font-size: 86px
    color: #ff2b2a
    font-weight: 500
    letter-spacing: -0.03125em
    @include media-breakpoint-down($md)
        font-size: 50px
    @include media-breakpoint-down($sm)
        font-size: 36px
.baseline
    font-size: 28px
    margin-top: 1.2em
    @include media-breakpoint-down($md)
        font-size: 20px
p,
label
    font-size: 17px
    color: #646873
    line-height: 1.5
    margin-top: 1.2em
    margin-bottom: 1.2em
    letter-spacing: 0.15em
    font-weight: 300
.select label,
.radio p
    font-size: 22px
    margin-right: 6.25%
    @include media-breakpoint-down($md)
        font-size: 17px
.select
    display: flex
    align-items: center
    position: relative
    &:after
        content: "\25be"
        display: block
        position: absolute
        right: 0
        top: 50%
        transform: translateY(-50%)
        font-size: 1.25em

    select
        flex: 1
        flex-basis: 60px
        border-bottom: 1px solid #646873
        font-size: 22px
        font-family: inherit
        font-weight: 500
        letter-spacing: 0.1em
        padding: 1.15em 0
        height: auto
        @include media-breakpoint-down($md)
            font-size: 17px

.choice
    display: flex
    align-items: center
    label
        font-size: 22px
        font-weight: 500
    &+.choice
        margin-left: 4%
input + label
    margin-left: .625em
.cta
    border: 1px solid rgba(0,0,0, .15)
    &.disabled
        pointer-events: none
        opacity: .15

input[type="text"]
    font-size: 22px
    font-family: inherit
    font-weight: 500
    letter-spacing: 0.1em
    width: 100%
    border-bottom: 1px solid #646873
    padding: 1.5em 0
    @include media-breakpoint-down($md)
        font-size: 17px
input:invalid
    color: #ff2b2a
    border-color: #ff2b2a
    &::-webkit-input-placeholder
        color: #ff2b2a
    &::-moz-placeholder
        color: #ff2b2a


.submit-container
    align-self: flex-end
    margin-bottom: 20px
</style>
